<template>
  <div>
    <Breadcrumb origin-name="Standorte" origin-path="/locations" :current-name="location.name" />
    <h3>Verwalter verwalten</h3>
    <List :columns="columns" :values="admins" emptyText="Bisher keine Verwalter vorhanden">
      <template #column_name="{data}">{{ data.firstName }} {{ data.lastName }}</template>
      <template #column_action="{data}">
        <div class="d-flex justify-content-center">
          <img @click="managerToDelete = data" src="../../assets/icons/remove.svg" />
        </div>
      </template>
    </List>
    <button @click="$router.push('manager/add')" class="btn btn-primary">Verwalter hinzufügen</button>
    <Dialog :visible="managerToDelete"
            title="Manager entfernen?"
            ok-button-text="Ja, entfernen!"
            @cancel="managerToDelete = undefined"
            @ok="removeManager"
            :message="`Wollen Sie ${managerToDelete ? managerToDelete.firstName : ''} ${managerToDelete ? managerToDelete.lastName : ''} wirklich entfernen?`">
    </Dialog>
  </div>
</template>

<script>
import Breadcrumb from "@/components/partial/Breadcrumb.vue";
import {communicator} from "@/util/communicator";
import {broadcast} from "@/util/eventHandler";
import List from "@/components/partial/List.vue";
import Dialog from "@/components/partial/Dialog.vue";

export default {
  components: {Dialog, List, Breadcrumb},
  name: "Manager",
  data() {
    return {
      managerToDelete: undefined,
      admins: [],
      location: [],
      columns: [
        { name: "Name", key: "name" },
        { name: "E-Mail Adresse", key: "email" },
        { name: "Aktion", key: "action", styles: { width: "75px" } },
      ]
    };
  },
  created() {
    if(this.$route.params.id) {
      this.loadManager(this.$route.params.id);
      this.location = this.$store.state.locations.find(e => String(e.id) === this.$route.params.id);
    }
  },
  methods: {
    async loadManager(id) {
      try {
        const response = await communicator.get("/locations/" + id + "/manager");
        this.admins = response.data.items;
      } catch (e) {
        broadcast("error", e.response.data);
      }
    },
    async removeManager() {
      if(!this.managerToDelete) return;
      try {
        await communicator.delete("/locations/" + this.$route.params.id + "/manager/" + this.managerToDelete.id);
        this.managerToDelete = undefined;
        this.loadManager(this.$route.params.id);
      } catch (e) {
        broadcast("error", e.response.data);
      }
    }
  }
};
</script>

<style lang="scss">
.d-flex img:hover {
  cursor: pointer;
}
</style>
